import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import HelpdeskTipoChamadoService from "service/helpdesk/HelpdeskTipoChamadoService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const helpdeskTipoChamadoService = new HelpdeskTipoChamadoService();

export default function HelpdeskTipoChamadoListagem() {

    const defaultFilters: DataTableFilterMeta = {
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    

    return (

        <BaseListagem ordenacao="id,ASC" service={helpdeskTipoChamadoService} urlService="/helpdeskTipoChamado" tituloPagina={'Tipos de Chamado do Helpdesk'} defaultFilters={defaultFilters} showClearFilterButton nome="helpdeskTipoChamado" >
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} 
                headerStyle={{ width: "100%" }} />
            <Column field="compra" header="Compra?" style={{ width: '5em', textAlign: "center" }} body={(rowData)=><Checkbox checked={rowData.compra} />} />
        </BaseListagem>
    )
}